import React from "react";
import { Chip, Group, Text } from '@mantine/core';

const CustomerCategorySelectorMultiple = ({
    stateValue = [],
    fnOnChange,
    stateData = [],
    stateDataLoading = false,
    stateDataFlag = 'idle',

    stateController = true,
    fnController,
}) => {
    return (
        <React.Fragment>
            {(Array.isArray(stateData) && (stateData.length > 0) && !stateDataLoading && stateDataFlag !== 'idle') &&
                <Group spacing='xs'>
                    <Chip
                        checked={stateController}
                        onChange={fnController}
                        radius='sm'
                    >
                        Semua
                    </Chip>

                    <Chip.Group
                        multiple
                        value={stateValue}
                        onChange={fnOnChange}
                    >
                        <Group spacing='xs'>
                            {Array.isArray(stateData) && Object.keys(stateData).map((keyCC, indexCC) => {
                                return (
                                    <Chip
                                        key={keyCC}
                                        value={String(stateData[keyCC].customer_category_slug)}
                                        radius='sm'
                                    >
                                        {stateData[keyCC].customer_category_name}
                                    </Chip>
                                )
                            })}
                        </Group>
                    </Chip.Group>
                </Group>
            }

            {(Array.isArray(stateData) && (stateData.length <= 0) && !stateDataLoading && stateDataFlag !== 'idle') &&
                <Text color="dimmed" size='sm' fs='italic'>Tidak ada data kategori customer</Text>
            }

            {stateDataLoading &&
                <Text color="dimmed" size='sm' fs='italic'>Loading kategori customer...</Text>
            }
        </React.Fragment>
    )
}

export default CustomerCategorySelectorMultiple;